export const tableImages = {
  // Circle tables of 1 pax
  circle_available_1: require("../../../../assets/images/tablemanagement/table/1-circle-available.svg"),
  circle_dirty_1: require("../../../../assets/images/tablemanagement/table/1-circle-dirty.svg"),
  circle_occupied_1: require("../../../../assets/images/tablemanagement/table/1-circle-occupied.svg"),
  circle_on_hold_1: require("../../../../assets/images/tablemanagement/table/1-circle-onhold.svg"),
  circle_unavailable_1: require("../../../../assets/images/tablemanagement/table/1-circle-unavailable.svg"),

  // Square tables of 1 pax
  square_available_1: require("../../../../assets/images/tablemanagement/table/1-square-available.svg"),
  square_dirty_1: require("../../../../assets/images/tablemanagement/table/1-square-dirty.svg"),
  square_occupied_1: require("../../../../assets/images/tablemanagement/table/1-square-occupied.svg"),
  square_on_hold_1: require("../../../../assets/images/tablemanagement/table/1-square-onhold.svg"),
  square_unavailable_1: require("../../../../assets/images/tablemanagement/table/1-square-unavailable.svg"),

  // Circle tables of 2 pax
  circle_available_2: require("../../../../assets/images/tablemanagement/table/2-circle-available.svg"),
  circle_dirty_2: require("../../../../assets/images/tablemanagement/table/2-circle-dirty.svg"),
  circle_occupied_2: require("../../../../assets/images/tablemanagement/table/2-circle-occupied.svg"),
  circle_on_hold_2: require("../../../../assets/images/tablemanagement/table/2-circle-onhold.svg"),
  circle_unavailable_2: require("../../../../assets/images/tablemanagement/table/2-circle-unavailable.svg"),

  // Square tables of 2 pax
  square_available_2: require("../../../../assets/images/tablemanagement/table/2-square-available.svg"),
  square_dirty_2: require("../../../../assets/images/tablemanagement/table/2-square-dirty.svg"),
  square_occupied_2: require("../../../../assets/images/tablemanagement/table/2-square-occupied.svg"),
  square_on_hold_2: require("../../../../assets/images/tablemanagement/table/2-square-onhold.svg"),
  square_unavailable_2: require("../../../../assets/images/tablemanagement/table/2-square-unavailable.svg"),

  // Circle tables of 3 pax
  circle_available_3: require("../../../../assets/images/tablemanagement/table/3-circle-available.svg"),
  circle_dirty_3: require("../../../../assets/images/tablemanagement/table/3-circle-dirty.svg"),
  circle_occupied_3: require("../../../../assets/images/tablemanagement/table/3-circle-occupied.svg"),
  circle_on_hold_3: require("../../../../assets/images/tablemanagement/table/3-circle-onhold.svg"),
  circle_unavailable_3: require("../../../../assets/images/tablemanagement/table/3-circle-unavailable.svg"),

  // Square tables of 3 pax
  square_available_3: require("../../../../assets/images/tablemanagement/table/3-square-available.svg"),
  square_dirty_3: require("../../../../assets/images/tablemanagement/table/3-square-dirty.svg"),
  square_occupied_3: require("../../../../assets/images/tablemanagement/table/3-square-occupied.svg"),
  square_on_hold_3: require("../../../../assets/images/tablemanagement/table/3-square-onhold.svg"),
  square_unavailable_3: require("../../../../assets/images/tablemanagement/table/3-square-unavailable.svg"),

  // Circle tables of 4 pax
  circle_available_4: require("../../../../assets/images/tablemanagement/table/4-circle-available.svg"),
  circle_dirty_4: require("../../../../assets/images/tablemanagement/table/4-circle-dirty.svg"),
  circle_occupied_4: require("../../../../assets/images/tablemanagement/table/4-circle-occupied.svg"),
  circle_on_hold_4: require("../../../../assets/images/tablemanagement/table/4-circle-onhold.svg"),
  circle_unavailable_4: require("../../../../assets/images/tablemanagement/table/4-circle-unavailable.svg"),

  // Square tables of 4 pax
  square_available_4: require("../../../../assets/images/tablemanagement/table/4-square-available.svg"),
  square_dirty_4: require("../../../../assets/images/tablemanagement/table/4-square-dirty.svg"),
  square_occupied_4: require("../../../../assets/images/tablemanagement/table/4-square-occupied.svg"),
  square_on_hold_4: require("../../../../assets/images/tablemanagement/table/4-square-onhold.svg"),
  square_unavailable_4: require("../../../../assets/images/tablemanagement/table/4-square-unavailable.svg"),

  // rectangle - 1
  rectangle_available_1: require("../../../../assets/images/tablemanagement/table/1-rectangle-available.png"),
  rectangle_dirty_1: require("../../../../assets/images/tablemanagement/table/1-rectangle-dirty.png"),
  rectangle_occupied_1: require("../../../../assets/images/tablemanagement/table/1-rectangle-occupied.png"),
  rectangle_on_hold_1: require("../../../../assets/images/tablemanagement/table/1-rectangle-onhold.png"),
  rectangle_unavailable_1: require("../../../../assets/images/tablemanagement/table/1-rectangle-unavailable.png"),

  // rectangle - 2
  rectangle_available_2: require("../../../../assets/images/tablemanagement/table/2-rectangle-available.png"),
  rectangle_dirty_2: require("../../../../assets/images/tablemanagement/table/2-rectangle-dirty.png"),
  rectangle_occupied_2: require("../../../../assets/images/tablemanagement/table/2-rectangle-occupied.png"),
  rectangle_on_hold_2: require("../../../../assets/images/tablemanagement/table/2-rectangle-onhold.png"),
  rectangle_unavailable_2: require("../../../../assets/images/tablemanagement/table/2-rectangle-unavailable.png"),

  // rectangle - 3
  rectangle_available_3: require("../../../../assets/images/tablemanagement/table/3-rectangle-available.png"),
  rectangle_dirty_3: require("../../../../assets/images/tablemanagement/table/3-rectangle-dirty.png"),
  rectangle_occupied_3: require("../../../../assets/images/tablemanagement/table/3-rectangle-occupied.png"),
  rectangle_on_hold_3: require("../../../../assets/images/tablemanagement/table/3-rectangle-onhold.png"),
  rectangle_unavailable_3: require("../../../../assets/images/tablemanagement/table/3-rectangle-unavailable.png"),

  // rectangle - 4
  rectangle_available_4: require("../../../../assets/images/tablemanagement/table/4-rectangle-available.png"),
  rectangle_dirty_4: require("../../../../assets/images/tablemanagement/table/4-rectangle-dirty.png"),
  rectangle_occupied_4: require("../../../../assets/images/tablemanagement/table/4-rectangle-occupied.png"),
  rectangle_on_hold_4: require("../../../../assets/images/tablemanagement/table/4-rectangle-onhold.png"),
  rectangle_unavailable_4: require("../../../../assets/images/tablemanagement/table/4-rectangle-unavailable.png"),

  // rectangle - 5
  rectangle_available_5: require("../../../../assets/images/tablemanagement/table/5-rectangle-available.svg"),
  rectangle_dirty_5: require("../../../../assets/images/tablemanagement/table/5-rectangle-dirty.svg"),
  rectangle_occupied_5: require("../../../../assets/images/tablemanagement/table/5-rectangle-occupied.svg"),
  rectangle_on_hold_5: require("../../../../assets/images/tablemanagement/table/5-rectangle-onhold.svg"),
  rectangle_unavailable_5: require("../../../../assets/images/tablemanagement/table/5-rectangle-unavailable.svg"),

  // rectangle - 6
  rectangle_available_6: require("../../../../assets/images/tablemanagement/table/6-rectangle-available.svg"),
  rectangle_dirty_6: require("../../../../assets/images/tablemanagement/table/6-rectangle-dirty.svg"),
  rectangle_occupied_6: require("../../../../assets/images/tablemanagement/table/6-rectangle-occupied.svg"),
  rectangle_on_hold_6: require("../../../../assets/images/tablemanagement/table/6-rectangle-onhold.svg"),
  rectangle_unavailable_6: require("../../../../assets/images/tablemanagement/table/6-rectangle-unavailable.svg"),

  // rectangle - 7
  rectangle_available_7: require("../../../../assets/images/tablemanagement/table/7-rectangle-available.svg"),
  rectangle_dirty_7: require("../../../../assets/images/tablemanagement/table/7-rectangle-dirty.svg"),
  rectangle_occupied_7: require("../../../../assets/images/tablemanagement/table/7-rectangle-occupied.svg"),
  rectangle_on_hold_7: require("../../../../assets/images/tablemanagement/table/7-rectangle-onhold.svg"),
  rectangle_unavailable_7: require("../../../../assets/images/tablemanagement/table/7-rectangle-unavailable.svg"),

  // rectangle - 8
  rectangle_available_8: require("../../../../assets/images/tablemanagement/table/8-rectangle-available.svg"),
  rectangle_dirty_8: require("../../../../assets/images/tablemanagement/table/8-rectangle-dirty.svg"),
  rectangle_occupied_8: require("../../../../assets/images/tablemanagement/table/8-rectangle-occupied.svg"),
  rectangle_on_hold_8: require("../../../../assets/images/tablemanagement/table/8-rectangle-onhold.svg"),
  rectangle_unavailable_8: require("../../../../assets/images/tablemanagement/table/8-rectangle-unavailable.svg"),

  // rectangle - 9
  rectangle_available_9: require("../../../../assets/images/tablemanagement/table/9-rectangle-available.svg"),
  rectangle_dirty_9: require("../../../../assets/images/tablemanagement/table/9-rectangle-dirty.svg"),
  rectangle_occupied_9: require("../../../../assets/images/tablemanagement/table/9-rectangle-occupied.svg"),
  rectangle_on_hold_9: require("../../../../assets/images/tablemanagement/table/9-rectangle-onhold.svg"),
  rectangle_unavailable_9: require("../../../../assets/images/tablemanagement/table/9-rectangle-unavailable.svg"),

  // rectangle - 10
  rectangle_available_10: require("../../../../assets/images/tablemanagement/table/10-rectangle-available.svg"),
  rectangle_dirty_10: require("../../../../assets/images/tablemanagement/table/10-rectangle-dirty.svg"),
  rectangle_occupied_10: require("../../../../assets/images/tablemanagement/table/10-rectangle-occupied.svg"),
  rectangle_on_hold_10: require("../../../../assets/images/tablemanagement/table/10-rectangle-onhold.svg"),
  rectangle_unavailable_10: require("../../../../assets/images/tablemanagement/table/10-rectangle-unavailable.svg"),

  // rectangle - 11
  rectangle_available_11: require("../../../../assets/images/tablemanagement/table/11-rectangle-available.svg"),
  rectangle_dirty_11: require("../../../../assets/images/tablemanagement/table/11-rectangle-dirty.svg"),
  rectangle_occupied_11: require("../../../../assets/images/tablemanagement/table/11-rectangle-occupied.svg"),
  rectangle_on_hold_11: require("../../../../assets/images/tablemanagement/table/11-rectangle-onhold.svg"),
  rectangle_unavailable_11: require("../../../../assets/images/tablemanagement/table/11-rectangle-unavailable.svg"),

  // rectangle - 12
  rectangle_available_12: require("../../../../assets/images/tablemanagement/table/12-rectangle-available.svg"),
  rectangle_dirty_12: require("../../../../assets/images/tablemanagement/table/12-rectangle-dirty.svg"),
  rectangle_occupied_12: require("../../../../assets/images/tablemanagement/table/12-rectangle-occupied.svg"),
  rectangle_on_hold_12: require("../../../../assets/images/tablemanagement/table/12-rectangle-onhold.svg"),
  rectangle_unavailable_12: require("../../../../assets/images/tablemanagement/table/12-rectangle-unavailable.svg"),

  // rectangle - 8
  Rectangle_8: require("../../../../assets/images/tablemanagement/table/Rectangle 8.svg"),

  // rectangle - 9
  Rectangle_9: require("../../../../assets/images/tablemanagement/table/Rectangle 9.svg"),
};
